import { ButtonPrev } from '@UI/Button'
import classNames from 'classnames'
import { FC, useEffect, useState } from 'react'
import cn from './index.module.css'
import { Tabs, TabsProps } from 'antd'
import CatalogCoursesTab from './tabs/CatalogCoursesTab/CatalogCoursesTab'
import { useSelector } from 'react-redux'
import { selectIsAuth, selectProfile } from '@store/profile.reducer'
import UnauthorizedCatalog from './tabs/UnauthorizedCatalog/UnauthorizedCatalog'
import { useHistory } from 'react-router-dom'
import { useGetSettings } from './tabs/CatalogCoursesTab/hooks/getPlatformSettings'
import MyCoursesTab from './tabs/MyCoursesTab/MyCoursesTab'

interface ICoursesCatalog {}

const CoursesCatalog: FC<ICoursesCatalog> = ({}) => {
  const tabs: TabsProps['items'] = [
    {
      label: 'Все курсы',
      key: '/courses/all',
    },
    {
      label: 'Мои курсы',
      key: '/v2/courses/my',
    },
  ]

  const { getSettings } = useGetSettings()
  const showUnauthorizedPage = getSettings(
    'catalogIsAvailableToUnauthorizedUsers',
  )
  const isAuth = useSelector(selectIsAuth)
  const profile = useSelector(selectProfile)
  const history = useHistory()

  const getSelectedTab = () => {
    return tabs.some((item) => item.key === history?.location?.pathname)
      ? history?.location?.pathname
      : tabs[0].key
  }

  const [selectedTab, setSelectedTab] = useState(getSelectedTab())

  useEffect(() => {
    if (!isAuth && showUnauthorizedPage === '0') {
      history.push('/auth')
    }
  }, [showUnauthorizedPage, isAuth])

  useEffect(() => {
    setSelectedTab(getSelectedTab())
  }, [history?.location?.pathname])

  if (!isAuth) {
    return <UnauthorizedCatalog />
  }

  const handleTabChange = (key: '/v2/courses/my' | '/courses/all') => {
    if (key === '/v2/courses/my') {
      switch (profile.role) {
        case 'admin':
          history.push('/courses-check')
          return
        case 'junior-admin':
          history.push('/courses-check')
          return
      }
    }
    setSelectedTab(key)
    history.push(`${key}`)
  }

  return (
    <main className={classNames('page-content', cn.page)}>
      <div className={cn.pageHeader}>
        <div className={classNames('newDesignHeader', cn.headerLeftSide)}>
          <ButtonPrev newDesign={true} link={null} />
          <div className="newDesignTitleText">Каталог курсов</div>
        </div>
        <Tabs
          items={tabs}
          onChange={(key) =>
            handleTabChange(key as '/v2/courses/my' | '/courses/all')
          }
          className={cn.customTabs}
          activeKey={selectedTab ?? undefined}
        />
        <div className={cn.headerRightSide}></div>
      </div>
      {selectedTab === '/courses/all' && <CatalogCoursesTab />}
      {selectedTab === '/v2/courses/my' && <MyCoursesTab />}
    </main>
  )
}

export default CoursesCatalog
